<template>
    <header class="app-header">
        <div class="header-container">
            <!-- Logo -->
            <div class="logo-container" @click="$emit('navigate', 'home')">
                <img src="../assets/materials/logo.svg" alt="泓域文化传媒" class="logo">
            </div>

            <!-- 主导航栏（PC 显示） -->
            <nav class="main-nav">
                <ul class="nav-list">
                    <li v-for="section in sections" :key="section.id" class="nav-item">
                        <button class="nav-button"
                                :class="{
                                    'active': activeButton === section.id,
                                    'user-scrolled': hasEverScrolled
                                }"
                                @click="handleNavigate(section.id)">
                            {{ section.title }}
                            <span class="hover-bg"></span>
                        </button>
                    </li>
                </ul>
            </nav>

            <!-- 汉堡按钮（移动端显示） -->
            <button class="hamburger" @click="toggleSidebar" aria-label="切换菜单">
                ☰
            </button>
        </div>

        <!-- 右侧侧边栏（移动端使用） -->
        <aside class="sidebar" :class="{ active: isSidebarOpen }">
            <div class="sidebar-header">
                <button class="close-btn" @click="toggleSidebar">×</button>
            </div>
            <nav class="sidebar-nav">
                <ul class="nav-list">
                    <li v-for="section in sections" :key="section.id" class="nav-item">
                        <button class="nav-button"
                                :class="{
                                    'active': activeButton === section.id,
                                    'user-scrolled': hasEverScrolled
                                }"
                                @click="handleNavigate(section.id)">
                            {{ section.title }}
                            <span class="hover-bg"></span>
                        </button>
                    </li>
                </ul>
            </nav>
        </aside>
    </header>
</template>

<script>
    export default {
        name: 'AppHeader',
        props: {
            sections: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                isSidebarOpen: false,
                activeButton: null,
                hasEverScrolled: false,
                isAutoScrolling: false,
                scrollTimeout: null,
                windowWidth: window.innerWidth
            };
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
            window.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
            window.removeEventListener('scroll', this.handleScroll);
            if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
        },
        methods: {
            toggleSidebar() {
                this.isSidebarOpen = !this.isSidebarOpen;
            },
            handleNavigate(id) {
                this.activeButton = id;
                this.$emit('navigate', id);
                this.hasEverScrolled = false;
                this.isAutoScrolling = true;

                // 设置超时，防止滚动事件未触发
                if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
                this.scrollTimeout = setTimeout(() => {
                    this.isAutoScrolling = false;
                }, 1000);

                if (this.windowWidth <= 992) {
                    this.toggleSidebar();
                }
            },
            handleResize() {
                this.windowWidth = window.innerWidth;
                if (this.windowWidth > 768) {
                    this.isSidebarOpen = false;
                }
            },
            handleScroll() {
                if (!this.isAutoScrolling && !this.hasEverScrolled) {
                    this.hasEverScrolled = true;
                }
            }
        }
    };
</script>

<style scoped>
    .app-header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background-color: white;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        z-index: 1000;
    }

    .header-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
        height: 80px;
        position: relative;
    }

    .logo-container {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .logo {
        height: 50px;
        transition: all 0.3s ease;
    }

    @media (max-width: 992px) {
        .logo {
            height: 40px;
        }
    }

    @media (max-width: 768px) {
        .logo {
            height: 35px;
        }
    }

    .main-nav {
        height: 100%;
    }

    .nav-list {
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0;
        height: 100%;
    }

    .nav-item {
        height: 100%;
        display: flex;
        align-items: center;
        width: 120px;
    }

    .nav-button {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        padding: 0 15px;
        border: none;
        background: none;
        font-size: 17px;
        color: #333;
        cursor: pointer;
        transition: all 0.3s ease;
    }

        .nav-button .hover-bg {
            opacity: 0;
        }

        .nav-button.active:not(.user-scrolled) .hover-bg {
            opacity: 1;
        }

    .hover-bg {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url('../assets/materials/menu-hover-bg.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 130px 80px;
        transition: opacity 0.3s ease;
        pointer-events: none;
        z-index: -1;
    }

    .hamburger {
        display: none;
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #333;
    }

    @media (max-width: 992px) {
        .nav-button {
            padding: 0 10px;
            font-size: 17px;
        }

        .main-nav {
            display: none;
        }

        .hamburger {
            display: block;
        }
    }

    .sidebar {
        position: fixed;
        top: 0;
        right: -300px;
        width: 150px;
        height: 100%;
        background-color: white;
        box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
        transition: right 0.3s ease;
        z-index: 999;
        overflow-y: auto;
        padding-top: 60px;
    }

        .sidebar.active {
            right: 0;
        }

    .sidebar-header {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 20px;
        box-sizing: border-box;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .close-btn {
        font-size: 28px;
        background: none;
        border: none;
        color: #333;
        cursor: pointer;
    }

    .sidebar-nav {
        padding: 20px;
    }

    .sidebar .nav-list {
        display: flex;
        flex-direction: column;
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .sidebar .nav-item {
        width: 100%;
        margin-bottom: 10px;
    }

    .sidebar .nav-button {
        width: 100%;
        text-align: left;
        padding: 12px 0;
        font-size: 16px;
        color: #333;
        border: none;
        background: none;
        cursor: pointer;
        transition: color 0.3s ease;
    }
</style>